import Avatar from '../Avatar';
import Icon from '../Icon/Icon';
import './NavBar.scss';
import { useNavigate } from 'react-router-dom';
import SearchInput from './SearchInput';

export default function NavBar() {
  const navigate = useNavigate();

  const handleSearch = (query: string) => {
    // Implementar lógica de busca aqui
    console.log('Buscar:', query);
    // navigate(`/busca?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="nav-bar">
      <div
        data-testid="navbar-logo"
        className="nav-bar__logo"
        onClick={() => navigate('/menu-de-conta', { replace: true })}
      >
        <h5>Conta SBT</h5>
      </div>

      <SearchInput onSearch={handleSearch} />

      <div className="nav-bar__menu">
        <button
          className="nav-bar__help-btn"
          onClick={() => window.open('https://sbt.com.br/faq', '_blank')}
          title="Ajuda"
        >
          <Icon name="help" />
        </button>
        <Avatar src="" />
      </div>
    </div>
  );
}
